import { render } from "./desktop_nav.vue?vue&type=template&id=4ae1f841"
import script from "./desktop_nav.js?vue&type=script&lang=js&external"
export * from "./desktop_nav.js?vue&type=script&lang=js&external"

import "./desktop_nav.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__